import { memo } from "react";
import { classNames, formatCurrency } from "helpers";
import { calculateBillingLineNet, calculateBillingLineTotal } from "services/api/finance/billing/calculations";
import { Badge } from "ui/components/Badge";
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";

/**
 * Stavka ulaznog računa u proširenom retku pretrage. Iznosi se računaju iz cijene i popusta,
 * jednako kao na samom računu, da se prikaz ne razilazi s njim.
 */
const InvoiceIncomingItemRowChild: React.FC<TableRowChildProps> = (props) => {
  const { index, row } = props;

  const net = calculateBillingLineNet(row);
  const total = calculateBillingLineTotal(row);

  return (
    <tr className={classNames(
      "hover:bg-slate-100",
      // Neraspoređena stavka se izdvaja bojom — po njoj se vidi što još čeka trošak.
      row.isAllocated
        ? (index % 2 === 0 ? "bg-white" : "bg-slate-50")
        : "bg-amber-50"
    )}>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.code ?? "-"}
      </td>
      <td className="px-4 py-2 text-sm font-medium text-slate-900">
        {row.name ?? "-"}
      </td>
      <td className="px-4 py-2 text-sm">
        {row.quantity ?? "-"}
      </td>
      <td className="px-4 py-2 text-sm">
        {formatCurrency.format(row.priceWithoutTax ?? 0)}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.taxRate != null ? `${row.taxRate} %` : "-"}
      </td>
      <td className="px-4 py-2 text-sm">
        {formatCurrency.format(net)}
      </td>
      <td className="px-4 py-2 text-sm font-medium">
        {formatCurrency.format(total)}
      </td>
      <td className="px-4 py-2 text-sm">
        <Badge
          text={row.isAllocated ? "Raspoređeno" : "Nije raspoređeno"}
          variant={row.isAllocated ? "success" : "warning"}
          height="small"
          showDot
        />
      </td>
    </tr>
  );
};

export default memo(InvoiceIncomingItemRowChild);
